// extracted by mini-css-extract-plugin
export default {"footerWrap":"footer_footerWrap__vdl2R","footerText":"footer_footerText__01Jek"};